<ng-container *ngIf="plt.isConnected && user && user.header_notifications && userLang && !callView">

    <ng-container *ngIf="!event?.enable_static_live_voting">
        <ng-container *ngFor="let notification of liveVotings; let i = index">
            <div *ngIf="!chatGroupLiveVoting || i == 0"
                 [ngClass]="{'chat-view': chatView, 'stream-view': streamView, 'detail-visible': detailVisible}"
                 class="row header-notification voting"
                 (click)="checkNotificationEvent(notification);">
                <p *ngIf="!plt.tabMenu">{{ "HEADER_NOTIFICATIONS_NEW_LIVE_VOTING_TEXT" | translate }}</p>
                <p *ngIf="plt.tabMenu">{{ "HEADER_NOTIFICATIONS_NEW_LIVE_VOTING_TEXT_MOBILE" | translate }}</p>
                <ion-button>{{ 'HEADER_NOTIFICATIONS_SHOW_VOTING' | translate }}</ion-button>
            </div>
        </ng-container>
    </ng-container>

    <ng-container *ngFor="let notification of user.header_notifications">
        <div *ngIf="!plt.tabMenu && notification.data.type == 'invitation'"
             [ngClass]="{'chat-view': chatView, 'stream-view': streamView, 'detail-visible': detailVisible}"
             class="row header-notification">
            <p *ngIf="!notification.data.community">{{ "HEADER_NOTIFICATIONS_NEW_INVITATION_TEXT" | translate: {'name': notification.data.event_name, 'date': notification.data.event_starts_at |
                datex:'dateTimeFormatDefault':null:true} }}</p>
            <p *ngIf="notification.data.community">{{ "HEADER_NOTIFICATIONS_NEW_INVITATION_TEXT_COMMUNITY" | translate: {'name': notification.data.event_name} }}</p>
            <ion-button (click)="feedAccept(notification);">{{ 'BUTTON_ACCEPT' | translate}}</ion-button>
            <ion-button (click)="feedDecline(notification);">{{ 'BUTTON_DECLINE' | translate}}</ion-button>
            <ion-button (click)="feedPostpone(notification);">{{ 'BUTTON_POSTPONE' | translate}}</ion-button>
        </div>
        <div *ngIf="!plt.tabMenu && notification.data.type == 'invitation-to-community'"
             [ngClass]="{'chat-view': chatView, 'stream-view': streamView, 'detail-visible': detailVisible}"
             class="row header-notification">
            <p>{{ "REGISTRATION_LABEL_TRANSFER_ACCEPTED" | translate:{'eventName': notification.data.eventName} }}</p>
            <ion-button (click)="feedAccept(notification);">{{ 'BUTTON_ACCEPT' | translate}}</ion-button>
            <ion-button (click)="feedDecline(notification);">{{ 'BUTTON_DECLINE' | translate}}</ion-button>
            <ion-button (click)="feedPostpone(notification);">{{ 'BUTTON_POSTPONE' | translate}}</ion-button>
        </div>
    </ng-container>

    <ng-container *ngIf="plt.tabMenu && user && user.header_notifications && invitationCount">
        <div class="row header-notification"
             [ngClass]="{'chat-view': chatView, 'stream-view': streamView, 'detail-visible': detailVisible}"
             (click)="openInvitations();">
            <p *ngIf="invitationCount == 1">{{ "HEADER_NOTIFICATIONS_NEW_INVITATION_TEXT" | translate: {'name': invitation.event_name, 'date': invitation.event_starts_at |
                datex:'dateTimeFormatDefault':null:true} }}</p>
            <p *ngIf="invitationCount > 1">{{ "HEADER_NOTIFICATIONS_NEW_INVITATION_TEXT_MULTI" | translate }}</p>
        </div>
    </ng-container>

</ng-container>